import {SequenceData} from "course/SequenceData";
import {Assert} from "common/Assert";

export function SequenceDataMap(){

    // this map will containing all accessible sequences after the initCourse-function was called
    let sequenceDataMap = {},
        scoreIDs = "";

    function getSequenceData(id) {
        if( typeof sequenceDataMap[id]  !== "undefined") {
            return sequenceDataMap[id];
        }
        return null;
    }

    function initSequenceData( id ) {
        const sequenceData = getSequenceData( id );
        if( !sequenceData ) {
            sequenceDataMap[id] = new SequenceData();
        }
        return sequenceDataMap[id];
    }

    function getResultMap(){

        let resultMap = {},
            id;

        for( id in sequenceDataMap ) {

            if( !sequenceDataMap.hasOwnProperty(id) ) {
                continue;
            }

            if( sequenceDataMap[id].isExecutable() || sequenceDataMap[id].isResultRelevant() ) {
                resultMap[id] = sequenceDataMap[id];
            }
        }

        return resultMap;
    }

    // revealing public api
    return {

        /**
         * @param id
         */
        initSequenceData: initSequenceData,

        /**
         * @param id
         * @returns the sequence data of the element with id <sId> or null
         */
        getSequenceData: getSequenceData,

        /**
         * @param id
         * @param newSequenceData @Nullable
         * @returns null or the sequence data of <sId> extended by newSequenceData
         */
        setSequenceData: function( id, newSequenceData ) {
            Assert.checkArgumentType( id, "string" );

            if (!newSequenceData) {
                return null;
            }

            Assert.checkArgumentType( newSequenceData.getData, "function",
                "Function getData() doesn't exists in newSequenceData!" );

            let sequenceData = getSequenceData(id);
            if (!sequenceData) {
                sequenceData = initSequenceData(id);
            }

            sequenceData.extendData( newSequenceData.getData() );

            return sequenceData;
        },

        /**
         * returns the seqeunceDataMap
         */
        getSequenceDataMap: function () {
            return sequenceDataMap;
        },

        /**
         * clears the sequence data map.
         */
        clearSequenceDataMap: function () {
            sequenceDataMap = {};
        },

        /**
         * @return {Object} an object with the following content {
         *         { learningScos: number, resultRelevantScos: number, assessmentScos: number
         *           getAvailableScos: (function(): number),
         *           getResultRelevantScos: getResultRelevantScos }
         *         }
         */
        getSequenceInfos: function () {

            let objInfos = {

                learningScos: 0,
                assessmentScos: 0,
                resultRelevantScos: 0,

                getAvailableScos: function () {
                    return this.learningScos + this.assessmentScos;
                },

                getResultRelevantScos: function () {

                    if (this.resultRelevantScos > 0) {
                        return this.resultRelevantScos;
                    }

                    if (this.assessmentScos > 0) {
                        return this.assessmentScos;
                    }

                    return this.learningScos;
                }
            },
            sId;

            for( sId in sequenceDataMap ) {

                if (!sequenceDataMap.hasOwnProperty(sId)) {
                    continue;
                }

                if (sequenceDataMap[sId].isELearning()) {
                    objInfos.learningScos++;
                }

                if (sequenceDataMap[sId].isAssessment()) {
                    objInfos.assessmentScos++;
                }

                if (sequenceDataMap[sId].isResultRelevant()) {
                    objInfos.resultRelevantScos++;
                }
            }

            return objInfos;
        },

        /**
         * This will initialize the field <sScoreIDs> that you can get with getScoreIDs().
         * The field is a comma separated list of executables scos.
         *
         * @param useAssessments if true only assesments will be included to the result list.
         * @returns {boolean} true
         */
        initScoreIDs: function( useAssessments ) {

            let sIdList = "",
                sId;

            // If there are assessments present, only assessments will be relevant for passing the course.
            // Otherwise all learning sequences will be used.
            const sPostFix = useAssessments ? "am" : "lm";
            for (sId in sequenceDataMap) {

                if (!sequenceDataMap.hasOwnProperty(sId)) {
                    continue;
                }

                if ((sId.substr(sId.length - 2) === sPostFix) && sequenceDataMap[sId].isExecutable()) {
                    if (sIdList.length > 0) {
                        sIdList += ",";
                    }
                    sIdList += sId;
                }
            }

            if (sIdList.length > 0) {
                scoreIDs = sIdList;
            }

            return true;
        },

        /**
         * @returns {string} a comma separated list of executables scos. @see initScoreIDs
         */
        getScoreIDs: function () {
            return scoreIDs;
        },

        /**
         * @returns the result map. The result map contains the executable and result relevant elements
         *  from the sequence data map.
         */
        getResultMap: getResultMap
    };
}
